import { Client } from "@/types/page";
import { Price } from "@/types/price";
import { PricingVersion } from "@/types/pricingVersion";
import { PromotionCode } from "@/types/PromotionCode";
import {
    applyDiscountToCents,
    formatMoneyWithCurrency,
} from "@/utils/moneyFormatting";

export type TrialCostInput = {
    price: Price;
    pricingVersion: PricingVersion;
    promotionCode: PromotionCode | null;
    client: Client;
};

export type TrialCost = {
    baseAmountForDisplay: string | number;
    costAfterPromoForDisplay: string;
};

export function getTrialCost({
    price,
    pricingVersion,
    promotionCode,
    client,
}: TrialCostInput): TrialCost {
    const baseAmountForDisplay =
        pricingVersion.trialCostAmountForDisplay ??
        (price.priceGroup &&
        pricingVersion.trialCostAmountPerPriceGroupForDisplay
            ? pricingVersion.trialCostAmountPerPriceGroupForDisplay[
                  price.priceGroup
              ]
            : 0) ??
        0;
    const baseCents =
        pricingVersion.trialCostAmountCents ??
        (price.priceGroup && pricingVersion.trialCostAmountCentsPerPriceGroup
            ? pricingVersion.trialCostAmountCentsPerPriceGroup[price.priceGroup]
            : 0) ??
        0;
    const costAfterPromoForDisplay = formatMoneyWithCurrency(
        applyDiscountToCents(baseCents, promotionCode?.coupon),
        client.currency ?? "usd",
    );

    return { baseAmountForDisplay, costAfterPromoForDisplay };
}
